export const msgExportMenuItem = 'RFQ Export'; // EPDB-664
export const msgImportMenuItem = 'RFQ Import';
export const loaExportMenuItem = 'LOA Export';
export const SdExportMenuItem = 'SD Export';
export const SdImportMenuItem = 'SD Import';
export const msgCompleteAllItem = 'Complete All';
